import React from "react";
import StudioInfo from "@/components/contact/StudioInfo";
import ContactForm from "@/components/contact/ContactForm";

export default function Contact() {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative py-24 sm:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <span className="label-overline">/ 07 — Visit / call</span>
          <h2 className="font-display text-4xl sm:text-5xl mt-6 mb-6 leading-[1.05] font-semibold tracking-tight">
            Drop by the studio<br />or send your files.
          </h2>
          <StudioInfo />
        </div>

        <div className="lg:col-span-7">
          <ContactForm />
        </div>
      </div>
    </section>
  );
}
